// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./LoginPage.css";
// import logoImg from "./img/RootServices.jpeg";

// function LoginPage() {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [isAdmin, setIsAdmin] = useState(true);
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setErrorMessage("");
//     setIsLoading(true);

//     try {
//       const url = isAdmin
//         ? "https://www.actrofiteinfotech.com/rootservices/dashboard/admin_login.php"
//         : "https://www.actrofiteinfotech.com/rootservices/dashboard/employee_login.php";

//       const options = isAdmin
//         ? (() => {
//             const formData = new FormData();
//             formData.append("username", username);
//             formData.append("password", password);
//             return { method: "POST", body: formData };
//           })()
//         : {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ username, password }),
//           };

//       const res = await fetch(url, options);
//       const data = await res.json();

//       if ((isAdmin && data.success) || (!isAdmin && data.status === "success")) {
//         if (isAdmin) {
//           localStorage.setItem("owner_logged_in", "true");
//           const userObj = data.user || { username: data.username, city: data.city ?? "", state: data.state ?? "" };
//           localStorage.setItem("owner_user", JSON.stringify(userObj));
//           navigate("/admin-dashboard");
//         } else {
//           localStorage.setItem("employee_logged_in", "true");
//           localStorage.setItem("employee_username", username);
//           localStorage.setItem("employee_id", data.employee_id);
//           navigate("/employee-dashboard");
//         }
//       } else {
//         setErrorMessage(data.error || data.message || "Login failed.");
//       }
//     } catch (err) {
//       console.error(err);
//       setErrorMessage("Something went wrong. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="lp-container">
//       <div className="lp-card">
//         <img src={logoImg} alt="Logo" className="lp-logo" />
//         <h2 className="lp-title">{isAdmin ? "Admin Login" : "Employee Login"}</h2>
//         <p className="lp-subtitle">Sign in to your dashboard</p>

//         {/* Animated Toggle */}
//         <div className="lp-toggle">
//           <div className={`lp-toggle-slider ${isAdmin ? "admin-active" : "employee-active"}`}></div>
//           <span
//             className={`lp-toggle-option ${isAdmin ? "active" : ""}`}
//             onClick={() => setIsAdmin(true)}
//           >
//             🏢 Admin
//           </span>
//           <span
//             className={`lp-toggle-option ${!isAdmin ? "active" : ""}`}
//             onClick={() => setIsAdmin(false)}
//           >
//             👤 Employee
//           </span>
//         </div>

//         {errorMessage && <div className="lp-error">{errorMessage}</div>}
//         {isLoading && <div className="lp-loading">Logging in...</div>}

//         <form onSubmit={handleLogin} className="lp-form">
//           <input
//             type="text"
//             placeholder="Username"
//             value={username}
//             onChange={(e) => setUsername(e.target.value)}
//             required
//             className="lp-input"
//           />
//           <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             required
//             className="lp-input"
//           />
//           <button type="submit" className="lp-submit-btn">
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default LoginPage;


// LoginPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import logoImg from "./img/RootServices.jpeg";

function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(true);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    try {
      const url = isAdmin
        ? "https://www.actrofiteinfotech.com/rootservices/dashboard/admin_login.php"
        : "https://www.actrofiteinfotech.com/rootservices/dashboard/employee_login.php";

      const options = isAdmin
        ? (() => {
            const formData = new FormData();
            formData.append("username", username);
            formData.append("password", password);
            return { method: "POST", body: formData };
          })()
        : {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username, password }),
          };

      const res = await fetch(url, options);
      const data = await res.json();

      if ((isAdmin && data.success) || (!isAdmin && data.status === "success")) {
        if (isAdmin) {
          localStorage.setItem("owner_logged_in", "true");
          const userObj = data.user || { username: data.username, city: data.city ?? "", state: data.state ?? "" };
          localStorage.setItem("owner_user", JSON.stringify(userObj));
          navigate("/admin-dashboard");
        } else {
          localStorage.setItem("employee_logged_in", "true");
          localStorage.setItem("employee_id", data.employee_id);
          localStorage.setItem("employee_name", data.full_name); // ✅ Store employee full name
          navigate("/employee-dashboard");
        }
      } else {
        setErrorMessage(data.error || data.message || "Login failed.");
      }
    } catch (err) {
      console.error(err);
      setErrorMessage("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="lp-container">
      <div className="lp-card">
        <img src={logoImg} alt="Logo" className="lp-logo" />
        <h2 className="lp-title">{isAdmin ? "Admin Login" : "Employee Login"}</h2>
        <p className="lp-subtitle">Sign in to your dashboard</p>

        {/* Animated Toggle */}
        <div className="lp-toggle">
          <div className={`lp-toggle-slider ${isAdmin ? "admin-active" : "employee-active"}`}></div>
          <span
            className={`lp-toggle-option ${isAdmin ? "active" : ""}`}
            onClick={() => setIsAdmin(true)}
          >
            🏢 Admin
          </span>
          <span
            className={`lp-toggle-option ${!isAdmin ? "active" : ""}`}
            onClick={() => setIsAdmin(false)}
          >
            👤 Employee
          </span>
        </div>

        {errorMessage && <div className="lp-error">{errorMessage}</div>}
        {isLoading && <div className="lp-loading">Logging in...</div>}

        <form onSubmit={handleLogin} className="lp-form">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            className="lp-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="lp-input"
          />
          <button type="submit" className="lp-submit-btn">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
